export default [
  {
    path: '/student-profile',
    name: 'student_profile',
    component: () => import('@/views/for_student/profile/personal'),
    meta: { pageTitle: 'personal', breadcrumb: [{ text: 'personal', active: true }], permission: ['access_tab_profile','access_profile_personal'] },
  },

  {
    path: '/student-academic',
    name: 'student_academic',
    component: () => import('@/views/for_student/profile/academic'),
    meta: { pageTitle: 'academic', breadcrumb: [{ text: 'academic', active: true }], permission: ['access_tab_profile', 'access_profile_academic'] },
  },
  {
    path: '/offering/registration',
    name: 'offering_registration',
    component: () => import('@/views/for_student/offering/registration'),
    meta: { pageTitle: 'Course Registration', breadcrumb: [{ text: 'Course Registration', active: true }], permission: 'access_registrations' },
  },
  {
    path: '/services',
    name: 'Other',
    component: () => import('@/views/for_student/service/services/index'),
    meta: { pageTitle: 'Services', breadcrumb: [{ text: 'Services' }] },
  },
  {
    path: '/services/add',
    name: 'new_service',
    component: () => import('@/views/for_student/service/services/add'),
    meta: { pageTitle: 'Services', navActiveLink: 'Other', breadcrumb: [{ text: 'Services', to: '/services' }, { text: 'Add', active: true }] },
  },
  {
    path: '/services/show/:id',
    name: 'other_show',
    component: () => import('@/views/for_student/service/services/show'),
    meta: { pageTitle: 'Services', navActiveLink: 'Other', breadcrumb: [{ text: 'Services', to: '/services' }, { text: 'show', active: true }] },
  },
  {
    path: '/services/certification',
    name: 'certification',
    component: () => import('@/views/for_student/service/certification/index'),
    meta: { pageTitle: 'Certificates', breadcrumb: [{ text: 'Certificates' }], permission: ['access_tab_services', 'access_services_certificates'] },
  },
  {
    path: '/certification/show/:id',
    name: 'show_certificate',
    component: () => import('@/views/for_student/service/certification/show'),
    meta: { pageTitle: 'Certificates', breadcrumb: [{ text: 'Certificates' }], permission: ['access_tab_services', 'access_services_certificates'] },
  },
  {
    path: '/services/certification/add',
    name: 'add_certification',
    component: () => import('@/views/for_student/service/certification/add'),
    meta: { pageTitle: 'Certificates', breadcrumb: [{ text: 'Certificates', active: true }], permission: ['access_tab_services', 'access_services_certificates'] },
  },
  {
    path: '/services/certification/edit/:id',
    name: 'edit_certification',
    component: () => import('@/views/for_student/service/certification/add'),
    meta: { pageTitle: 'Certificates', breadcrumb: [{ text: 'Certificates', active: true }], permission: ['access_tab_services', 'access_services_certificates'] },
  },
  {
    path: '/myCourses',
    name: 'my_courses',
    component: () => import('@/views/for_student/my_courses/index'),
    meta: { pageTitle: 'My Courses', breadcrumb: [{ text: 'My Courses', active: true }], permission: 'access_my_courses' },
  },
  {
    path: '/myCourses/:course_id',
    name: 'show_my_course',
    component: () => import('@/views/for_student/my_courses/show'),
    meta: { pageTitle: 'Show Course', breadcrumb: [{ to: '/myCourses', text: 'My Courses' }, { text: 'Show Course', active: true }], permission: 'access_my_courses' },
  },
  {
    path: '/my_excuses',
    name: 'my_excuses',
    component: () => import('@/views/for_student/my_excuses/index'),
    meta: { pageTitle: 'My Excuses', breadcrumb: [{ text: 'Excuses', active: true }], permission: ['access_tab_services', 'access_services_excuses'] },
  },
  {
    path: '/my_excuses/add',
    name: 'add_excuse',
    component: () => import('@/views/for_student/my_excuses/edit.vue'),
    meta: { pageTitle: 'Excuses', breadcrumb: [{ to: '/my_excuses', text: 'Excuses' }], permission: ['access_tab_services', 'access_services_excuses'] },
  },
  {
    path: '/my_excuses/edit/:id',
    name: 'edit_excuse',
    component: () => import('@/views/for_student/my_excuses/edit.vue'),
    meta: { pageTitle: 'Excuses', breadcrumb: [{ to: '/my_excuses', text: 'Excuses' }], permission: ['access_tab_services', 'access_services_excuses'] },
  },

  {
    path: '/correction_requests',
    name: 'my_correction_requests',
    component: () => import('@/views/for_student/correction_requests/index'),
    meta: { pageTitle: 'My Correction Requests', breadcrumb: [{ text: 'My Correction Requests', active: true }], permission: ['access_tab_profile', 'access_profile_corrections'] },
  },
  {
    path: '/correction_requests/add',
    name: 'add_correction_request',
    component: () => import('@/views/for_student/correction_requests/add'),
    meta: { pageTitle: 'My Excuses', breadcrumb: [{ to: '/correction_requests', text: 'My Correction Requests' }, { text: 'Request New Correction', active: true }], permission: ['access_tab_profile', 'access_profile_corrections'] },
  },
  {
    path: '/schedule',
    name: 'my_schedule',
    component: () =>
      import('@/views/for_student/my_schedule/index'),
    meta: { pageTitle: 'My Schedule', breadcrumb: [{ text: 'Schedule', active: true }], permission: 'access_schedule' },
  },
  {
    path: '/calendar',
    name: 'my_calendar',
    component: () =>
      import('@/views/for_student/my_calendar/index'),
    meta: { pageTitle: 'My Calendar', breadcrumb: [{ text: 'Calendar', active: true }], permission: 'access_calender' },
  },

  //My Thesis
  {
    path: '/my_thesis',
    name: 'my_thesis',
    component: () => import('@/views/for_student/my_thesis/show'),
    meta: { pageTitle: 'my_thesis', breadcrumb: [{ text: 'my_thesis', active: true }], permission: 'access_theses_my' },
  },
  {
    path: '/my_theses/:id',
    name: 'show_thesis',
    component: () => import('@/views/for_student/my_thesis/show'),
    meta: { pageTitle: 'Show Thesis', breadcrumb: [{ to: '/my_theses', text: 'my_theses' }, { text: 'Show Thesis', active: true }], permission: ['access_tab_profile', 'access_theses_my'] },
  },
  {
    path: '/my_theses/add',
    name: 'add_thesis',
    component: () => import('@/views/for_student/my_thesis/edit'),
    meta: { pageTitle: 'my_theses', breadcrumb: [{ to: '/my_theses', text: 'my_theses' }], permission: ['access_tab_profile', 'access_theses_my'] },
  },
  {
    path: '/my_theses/edit/:id?',
    name: 'edit_thesis',
    component: () => import('@/views/for_student/my_thesis/edit'),
    meta: { pageTitle: 'my_theses', breadcrumb: [{ to: '/my_theses', text: 'my_theses' }], permission: ['access_tab_profile', 'access_theses_my'] },
  },

  {
    path: '/grades_recheck',
    name: 'grades_recheck',
    component: () => import('@/views/for_student/grades_recheck/index'),
    meta: {
      pageTitle: 'grades_recheck',
      breadcrumb: [
        { text: 'grades_recheck', active: true },
      ],
      permission: ['access_tab_services', 'access_students_grades_recheck'],
    },
  },
  {
    path: '/grades_recheck/add',
    name: 'add_grades_recheck',
    component: () => import('@/views/for_student/grades_recheck/edit'),
    meta: { pageTitle: 'grades_recheck', breadcrumb: [{ to: '/grades_recheck', text: 'grades_recheck' }], permission: ['access_tab_services', 'access_students_grades_recheck'] },
  },

  // Credit routes - legacy, not used in navigation
  {
    path: '/my_credit',
    name: 'credit',
    component: () => import('@/views/for_student/my_credit/index'),
    meta: { pageTitle: 'credit', breadcrumb: [{ text: 'credit', active: true }], public: true },
  },
  {
    path: '/my_credit/charge',
    name: 'charge_credit',
    component: () => import('@/views/for_student/my_credit/edit.vue'),
    meta: { pageTitle: 'credit', breadcrumb: [{ to: '/credit', text: 'credit' }], public: true },
  }
];
